/*--------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * See License.txt in the project root for license information.
 *--------------------------------------------------------------*/

import { Module, Node } from '@msdyn365-commerce-modules/utilities';
import * as React from 'react';

import {
    IAddressShowItem,
    IAddressShowProps
} from '@msdyn365-commerce-modules/address/src/modules/checkout-billing-address/../../common/components/address-show';
import { ICheckoutBillingAddressViewProps } from './b2b-checkout-billing-address';

/**
 * Address show component.
 * @param param0 - Root param.
 * @param param0.AddressDetail - Address detail.
 * @param param0.items - IAddressShowItem[].
 * @returns - Address Node.
 */
const AddressShow: React.FC<IAddressShowProps> = ({ AddressDetail, items }) => {
    return (
        <Node {...AddressDetail}>
            {items.map((item: IAddressShowItem) => {
                return <>{item.description}</>;
            })}
        </Node>
    );
};

/**
 * Checkout Billing Address View Component.
 * @param props - Props.
 * @returns - CheckoutBillingAddress Module.
 */
const CheckoutBillingAddressView: React.FC<ICheckoutBillingAddressViewProps> = props => {
    const { CheckoutBillingAddress, viewState, showAddress, error } = props;

    return (
        <Module {...CheckoutBillingAddress}>
            {viewState.isShowAddress && <AddressShow {...showAddress} />}
            {viewState.isError && error}
        </Module>
    );
};

export default CheckoutBillingAddressView;
